import React from 'react';
import './App.css';
import MainContent from './mainContent';
import Login from './login';

function App() {
  return (
    <div className="App">
      <Login />
      <MainContent />
    </div>
  );
}


export default (App);
